module.exports = __webpack_public_path__ + "img/甘肃文旅_01.02600b16.jpg";